export const translationConnectAi_da = {
  pageTitle: "Forbind dine AI-værktøjer",
  pageDescription:
    "Forbind Claude, Codex og andre AI-værktøjer direkte til jeres chatbot-data via MCP. I logger ind med jeres almindelige dashboard-konto — AI-værktøjet kan præcis det samme, som I selv kan i dashboardet.",

  serverUrlLabel: "MCP-server URL",
  copy: "Kopiér",
  copied: "Kopieret",
  copyTooltip: "Kopiér til udklipsholder",

  capabilitiesTitle: "Hvad kan I bruge det til?",
  capabilitiesDescription:
    "Når et AI-værktøj er forbundet, kan det arbejde direkte med jeres data — fx opdatere vidensbasen, analysere samtaler eller trække statistik, mens I skriver med det.",
  capabilityWorkspaceTitle: "Overblik",
  capabilityWorkspaceDescription:
    "Se jeres chatbots og vidensbaser, så AI-værktøjet ved, hvad det arbejder med.",
  capabilityRulesTitle: "Adfærdsregler",
  capabilityRulesDescription:
    "Læs, opret, redigér og slet regler — inkl. tidsstyrede regler (fx kampagner i en bestemt periode).",
  capabilityKnowledgeTitle: "Vidensbase",
  capabilityKnowledgeDescription:
    "Læs, tilføj og opdatér vidensbase-indhold. Ændringer bruges af chatbotten med det samme.",
  capabilityConversationsTitle: "Samtaler",
  capabilityConversationsDescription:
    "Find og læs samtaler, markér fejl, tilføj kommentarer og eksportér samtaler til analyse.",
  capabilityTestConversationsTitle: "Testsamtaler",
  capabilityTestConversationsDescription:
    "Hav testsamtaler med jeres chatbot præcis som en besøgende i chatwidgetten, begyndende med dens startbesked. Gemmes som testsamtaler med en lille grænse pr. time og pr. dag.",
  capabilityStatisticsTitle: "Statistik",
  capabilityStatisticsDescription:
    "Træk rapporter om beskeder, vurderinger, emner, køb, livechat og svartider.",

  connectTitle: "Sådan forbinder I",
  connectDescription:
    "Vælg det værktøj, I bruger. Første gang bliver I bedt om at logge ind med jeres dashboard-konto og godkende adgangen.",

  clientClaudeTitle: "Claude & Claude Cowork",
  clientClaudeDescription: "claude.ai, Claude Desktop og Cowork — tilføjes som connector.",
  clientClaudeButton: "Åbn Claude connectors",
  clientClaudeStep1: "Klik på knappen — den åbner Indstillinger → Connectors på claude.ai.",
  clientClaudeStep2: "Vælg “Tilføj brugerdefineret connector” og indsæt server-URL'en ovenfor.",
  clientClaudeStep3: "Log ind med din dashboard-konto og godkend adgangen.",

  clientClaudeCodeTitle: "Claude Code",
  clientClaudeCodeDescription: "Anthropics kodeagent i terminalen.",
  clientClaudeCodeStep1:
    "Kør kommandoen i din terminal. Den bruger en fast callback-port, så hold port 8080 fri, mens du logger ind:",
  clientClaudeCodeStep2: "Skriv derefter /mcp i Claude Code for at logge ind.",

  clientCodexTitle: "Codex",
  clientCodexDescription: "OpenAI's kodeagent (CLI og IDE-udvidelse).",
  clientCodexStep1: "Kør kommandoen i din terminal:",
  clientCodexStep2: "Log derefter ind med:",

  clientCursorTitle: "Cursor",
  clientCursorDescription: "AI-kodeeditor — understøtter installation med ét klik.",
  clientCursorButton: "Tilføj til Cursor",
  clientCursorStep1: "Klik på knappen (kræver at Cursor er installeret) og godkend serveren.",
  clientCursorStep2: "Log ind med din dashboard-konto, når Cursor beder om det.",

  clientVsCodeTitle: "VS Code",
  clientVsCodeDescription: "GitHub Copilot i VS Code — installation med ét klik.",
  clientVsCodeButton: "Tilføj til VS Code",
  clientVsCodeStep1: "Klik på knappen (kræver at VS Code er installeret) og bekræft.",
  clientVsCodeStep2: "Start serveren i VS Code og log ind med din dashboard-konto.",

  clientOtherTitle: "Andre MCP-klienter",
  clientOtherDescription:
    "Alle værktøjer, der understøtter remote MCP-servere (Streamable HTTP + OAuth), kan forbindes — fx ChatGPT (developer mode) eller MCP Inspector.",
  clientOtherStep1: "Tilføj en remote MCP-server med URL'en ovenfor.",
  clientOtherStep2: "Følg OAuth-login-flowet med din dashboard-konto.",

  firstToolHint:
    "Tip: Bed AI-værktøjet om at kalde get_workspace som det første — så kender det jeres chatbots og vidensbaser.",

  securityTitle: "Sikkerhed og adgang",
  securityBody:
    "Hver bruger logger ind med sin egen dashboard-konto, og AI-værktøjet får præcis de samme rettigheder som brugeren har i dashboardet — hverken mere eller mindre. Roller med læseadgang kan ikke ændre noget via MCP, og adgangen kan altid trækkes tilbage ved at fjerne brugeren fra organisationen.",
};
